export const feedBackButtonVisibility = (show: boolean) => {
  const sidebarButton = document.getElementById("sidebar-button");
  if (sidebarButton) {
    sidebarButton.style.display = show ? "block" : "none";
  }
};
